<!-- ClientsView.vue -->
<template>
  <div class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
    <!-- Header Section (same as before) -->
    <!-- <div class="mb-8 flex items-center justify-between">
      <div>
        <h1 class="text-3xl font-bold text-gray-800">Clients</h1>
        <p class="text-gray-600 mt-1">Manage your clients and their tickets</p>
      </div>
      <button
        @click="openCreateModal"
        class="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-xl shadow-lg transition-all duration-200 flex items-center gap-2 transform hover:scale-105"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
            clip-rule="evenodd"
          />
        </svg>
        Add New Client
      </button>
    </div> -->

    <!-- Stats Cards (same as before) -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <!-- ... stats cards content ... -->
      <div class="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-gray-500 text-sm">Total Clients</p>
            <p class="text-2xl font-bold text-gray-800">{{ clients.length }}</p>
          </div>
          <div class="bg-indigo-100 p-3 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-indigo-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-gray-500 text-sm">Verified</p>
            <p class="text-2xl font-bold text-green-600">{{ verifiedCount }}</p>
          </div>
          <div class="bg-green-100 p-3 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-green-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-gray-500 text-sm">Pending</p>
            <p class="text-2xl font-bold text-yellow-600">{{ pendingCount }}</p>
          </div>
          <div class="bg-yellow-100 p-3 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-yellow-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2xl shadow-sm p-6 border border-gray-100">
        <div class="flex items-center justify-between">
          <div>
            <p class="text-gray-500 text-sm">Total Tickets</p>
            <p class="text-2xl font-bold text-gray-800">{{ totalTickets }}</p>
          </div>
          <div class="bg-purple-100 p-3 rounded-xl">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6 text-purple-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <!-- Search and Filter Bar (updated with items per page) -->
    <div class="mb-6 flex flex-col sm:flex-row gap-4">
      <div class="flex-1 relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Search clients..."
          class="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 transition-all duration-200"
          @input="resetPagination"
        />
      </div>
      <select
        v-model="filterStatus"
        class="px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 transition-all duration-200 bg-white"
        @change="resetPagination"
      >
        <option value="all">All Status</option>
        <option value="verified">Verified</option>
        <option value="pending">Pending</option>
      </select>

      <!-- Items per page selector -->
      <select
        v-model="itemsPerPage"
        class="px-4 py-3 rounded-xl border border-gray-200 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 transition-all duration-200 bg-white"
      >
        <option :value="5">5 per page</option>
        <option :value="10">10 per page</option>
        <option :value="20">20 per page</option>
        <option :value="50">50 per page</option>
      </select>
    </div>

    <!-- Results summary -->
    <div class="mb-4 flex justify-between items-center text-sm text-gray-600">
      <span>
        Showing {{ paginationStart }} - {{ paginationEnd }} of
        {{ clients.length }} clients
      </span>
      <span class="bg-gray-100 px-3 py-1 rounded-full">
        Page {{ currentPage }} of {{ totalPages }}
      </span>
    </div>

    <!-- Clients Table -->
    <div
      class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
    >
      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="bg-gray-50 border-b border-gray-100">
              <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Client
              </th>
              <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Phone
              </th>
              <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Alt Phone
              </th>
              <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Status
              </th>
              <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Documents
              </th>
              <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Tickets
              </th>
              <!-- <th class="text-left py-4 px-6 text-gray-600 font-medium">
                Actions
              </th> -->
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="client in paginatedClients"
              :key="client.id"
              class="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-150"
            >
              <td class="py-4 px-6">
                <div class="flex items-center gap-3">
                  <span class="font-medium text-gray-800">{{
                    client.first_name +
                    " " +
                    client.middle_name +
                    " " +
                    client.last_name
                  }}</span>
                </div>
              </td>
              <td class="py-4 px-6 text-gray-600">
                {{ formatKenyanPhone(client.phone) }}
              </td>
              <td class="py-4 px-6 text-gray-600">
                {{ client.alt_phone || "N/A" }}
              </td>
              <td class="py-4 px-6">
                <span
                  :class="[
                    'px-3 py-1 rounded-full text-sm font-medium',
                    client.verified
                      ? 'bg-green-100 text-green-700'
                      : 'bg-yellow-100 text-yellow-700',
                  ]"
                >
                  {{ client.verified ? "Verified" : "Pending" }}
                </span>
              </td>
              <td class="py-4 px-6">
                <button
                  @click="viewTickets(client)"
                  class="flex items-center gap-2 text-indigo-600 hover:text-indigo-800 transition-colors duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path
                      fill-rule="evenodd"
                      d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  3 Documents
                </button>
              </td>
              <td class="py-4 px-6">
                <button
                  @click="viewTickets(client)"
                  class="flex items-center gap-2 text-indigo-600 hover:text-indigo-800 transition-colors duration-200"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path
                      fill-rule="evenodd"
                      d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                      clip-rule="evenodd"
                    />
                  </svg>
                  {{ client?.tickets?.length }} Tickets
                </button>
              </td>
              <!-- <td class="py-4 px-6">
                <div class="flex items-center gap-2">
                  <button
                    @click="openEditModal(client)"
                    class="p-2 text-gray-600 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all duration-200"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
                      />
                    </svg>
                  </button>
                  <button
                    @click="confirmDelete(client)"
                    class="p-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                </div>
              </td> -->
            </tr>

            <!-- Empty state -->
            <tr v-if="paginatedClients.length === 0">
              <td colspan="6" class="py-12 text-center text-gray-500">
                <svg
                  class="h-12 w-12 mx-auto mb-4 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                  />
                </svg>
                <p class="text-lg">No clients found</p>
                <p class="text-sm mt-1">
                  Try adjusting your search or filter criteria
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div class="mt-6 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <button
          @click="goToFirstPage"
          :disabled="currentPage === 1"
          class="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          :class="{ 'hover:bg-gray-50': currentPage !== 1 }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <button
          @click="previousPage"
          :disabled="currentPage === 1"
          class="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          :class="{ 'hover:bg-gray-50': currentPage !== 1 }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div class="flex items-center gap-2">
        <button
          v-for="page in displayedPages"
          :key="page"
          @click="goToPage(page)"
          :class="[
            'w-10 h-10 rounded-lg font-medium transition-all duration-200',
            currentPage === page
              ? 'bg-indigo-600 text-white shadow-md'
              : 'border border-gray-200 hover:bg-gray-50 text-gray-700',
          ]"
        >
          {{ page }}
        </button>
      </div>

      <div class="flex items-center gap-2">
        <button
          @click="nextPage"
          :disabled="currentPage === totalPages || totalPages === 0"
          class="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          :class="{ 'hover:bg-gray-50': currentPage !== totalPages }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
        <button
          @click="goToLastPage"
          :disabled="currentPage === totalPages || totalPages === 0"
          class="p-2 rounded-lg border border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          :class="{ 'hover:bg-gray-50': currentPage !== totalPages }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0zm-6 0a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Client Modal (same as before) -->
    <div
      v-if="showModal"
      class="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- ... modal content ... -->
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          @click="closeModal"
        ></div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"
          >&#8203;</span
        >

        <div
          class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        >
          <div class="bg-white px-6 pt-6 pb-4">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-xl font-semibold text-gray-900" id="modal-title">
                {{ modalMode === "create" ? "Add New Client" : "Edit Client" }}
              </h3>
              <button
                @click="closeModal"
                class="text-gray-400 hover:text-gray-500"
              >
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <form @submit.prevent="saveClient">
              <div class="space-y-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Name</label
                  >
                  <input
                    v-model="formData.name"
                    type="text"
                    required
                    class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Email</label
                  >
                  <input
                    v-model="formData.email"
                    type="email"
                    required
                    class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Phone</label
                  >
                  <input
                    v-model="formData.phone"
                    type="tel"
                    required
                    class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1"
                    >Verification Status</label
                  >
                  <select
                    v-model="formData.verified"
                    class="w-full px-4 py-2 rounded-lg border border-gray-300 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500"
                  >
                    <option :value="true">Verified</option>
                    <option :value="false">Pending</option>
                  </select>
                </div>
              </div>

              <div class="mt-6 flex justify-end gap-3">
                <button
                  type="button"
                  @click="closeModal"
                  class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors duration-200"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors duration-200"
                >
                  {{ modalMode === "create" ? "Create" : "Save Changes" }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Tickets Modal (same as before) -->
    <div
      v-if="showTicketsModal"
      class="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- ... tickets modal content ... -->
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          @click="closeTicketsModal"
        ></div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"
          >&#8203;</span
        >

        <div
          class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full"
        >
          <div class="bg-white px-6 pt-6 pb-4">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-xl font-semibold text-gray-900">
                Tickets - {{ selectedClient?.name }}
              </h3>
              <button
                @click="closeTicketsModal"
                class="text-gray-400 hover:text-gray-500"
              >
                <svg
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div class="space-y-4 max-h-96 overflow-y-auto">
              <div
                v-if="selectedClient?.tickets.length === 0"
                class="text-center py-8 text-gray-500"
              >
                No tickets found for this client.
              </div>
              <div
                v-for="ticket in selectedClient?.tickets"
                :key="ticket.id"
                class="border border-gray-200 rounded-xl p-4 hover:shadow-md transition-shadow duration-200"
              >
                <div class="flex items-start justify-between">
                  <div>
                    <h4 class="font-medium text-gray-800">
                      {{ ticket.title }}
                    </h4>
                    <p class="text-sm text-gray-600 mt-1">
                      {{ ticket.description }}
                    </p>
                    <div class="flex items-center gap-4 mt-2">
                      <span
                        :class="[
                          'px-2 py-1 rounded-full text-xs font-medium',
                          ticket.priority === 'high'
                            ? 'bg-red-100 text-red-700'
                            : ticket.priority === 'medium'
                            ? 'bg-yellow-100 text-yellow-700'
                            : 'bg-green-100 text-green-700',
                        ]"
                      >
                        {{ ticket.priority }}
                      </span>
                      <span
                        :class="[
                          'px-2 py-1 rounded-full text-xs font-medium',
                          ticket.status === 'open'
                            ? 'bg-blue-100 text-blue-700'
                            : ticket.status === 'in-progress'
                            ? 'bg-purple-100 text-purple-700'
                            : 'bg-gray-100 text-gray-700',
                        ]"
                      >
                        {{ ticket.status }}
                      </span>
                      <span class="text-xs text-gray-500">
                        Created:
                        {{ new Date(ticket.createdAt).toLocaleDateString() }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-6 flex justify-end">
              <button
                @click="closeTicketsModal"
                class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors duration-200"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Modal -->
    <div
      v-if="showDeleteModal"
      class="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- ... delete modal content ... -->
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          @click="closeDeleteModal"
        ></div>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen"
          >&#8203;</span
        >

        <div
          class="inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
        >
          <div class="bg-white px-6 pt-6 pb-4">
            <div class="flex items-center justify-center mb-4">
              <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100"
              >
                <svg
                  class="h-6 w-6 text-red-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
            </div>
            <h3 class="text-lg font-medium text-gray-900 text-center mb-2">
              Delete Client
            </h3>
            <p class="text-sm text-gray-500 text-center mb-6">
              Are you sure you want to delete {{ clientToDelete?.name }}? This
              action cannot be undone.
            </p>
            <div class="flex justify-center gap-3">
              <button
                @click="closeDeleteModal"
                class="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors duration-200"
              >
                Cancel
              </button>
              <button
                @click="deleteClient"
                class="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Action Button -->
    <button
      @click="getClients"
      class="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-800 text-white shadow-lg transition-all duration-300 hover:bg-indigo-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      aria-label="Refresh page"
    >
      <!-- Refresh icon (SVG) -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="{ 'animate-spin': isRefreshing }"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  </div>

  <div
    v-if="isRefreshing"
    class="fixed inset-0 ml-64 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
  >
    <div class="relative">
      <!-- Outer ring -->
      <div class="w-16 h-16 border-4 border-gray-200 rounded-full"></div>
      <!-- Inner spinning gradient ring -->
      <div
        class="w-16 h-16 border-4 border-transparent rounded-full absolute top-0 left-0 border-t-indigo-500 border-r-indigo-700 animate-spin"
      ></div>
      <!-- Center dot -->
      <div
        class="w-3 h-3 bg-indigo-800 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

import api from "@/utils/api";

import { useNotifications } from "@/composables/useNotifications";

// Notification system
const { showError, formatValidationErrors } = useNotifications();

// State
const isRefreshing = ref(false);
const paginatedClients = ref([]);
const clients = ref([]);
const showModal = ref(false);
const showTicketsModal = ref(false);
const showDeleteModal = ref(false);
const modalMode = ref("create");
const selectedClient = ref(null);
const clientToDelete = ref(null);
const searchQuery = ref("");
const filterStatus = ref("all");
const currentPage = ref(1);
const itemsPerPage = ref(10);

const formData = ref({
  name: "",
  email: "",
  phone: "",
  verified: false,
});

const formatKenyanPhone = (phoneNumber) => {
  if (!phoneNumber) return "N/A";

  try {
    // Convert to string and remove any non-digit characters
    const cleaned = String(phoneNumber).replace(/\D/g, "");

    // Check if it's a Kenyan number starting with 254
    if (cleaned.startsWith("254")) {
      // Remove '254' and ensure we have the remaining 9 digits
      const localNumber = cleaned.substring(3);

      // If we have exactly 9 digits after removing 254, format with leading 0
      if (localNumber.length === 9) {
        return "0" + localNumber;
      }
      // If we have 12 digits total (254 + 9 digits), take the last 9
      else if (cleaned.length === 12) {
        return "0" + cleaned.slice(-9);
      }
    }

    // Return original cleaned number if not in Kenyan format
    return cleaned;
  } catch (error) {
    console.log(error);
    return "N/A";
  }
};

const getClients = async () => {
  isRefreshing.value = true;
  try {
    const response = await api.get("/api/v1/clients");
    clients.value = response.data.data;
    paginatedClients.value = response.data.data;
  } catch (error) {
    console.log(error);
    const details = formatValidationErrors(error);
    showError("Error", "Failed to save user", details, 5000);
  } finally {
    isRefreshing.value = false;
  }
};

// Mock data
onMounted(() => {
  getClients();
});

// Computed
const verifiedCount = computed(() => {
  // return clients.value.filter((c) => c.is_profile_verified).length;
  return 0;
});

const pendingCount = computed(() => {
  // return clients.value.filter((c) => !c.is_profile_verified).length;
  return 0;
});

const totalTickets = computed(() => {
  // return clients.value.reduce((sum, client) => sum + client.tickets.length, 0);
  return 0;
});

// const filteredClients = computed(() => {
//   return clients.value.filter((client) => {
//     const matchesSearch =
//       client.first_name
//         .toLowerCase()
//         .includes(searchQuery.value.toLowerCase()) ||
//       client.phone.toLowerCase().includes(searchQuery.value.toLowerCase());
//     const matchesFilter =
//       filterStatus.value === "all" ||
//       (filterStatus.value === "verified" && client.verified) ||
//       (filterStatus.value === "pending" && !client.verified);
//     return matchesSearch && matchesFilter;
//   });
// });

// const totalPages = computed(() => {
//   return Math.ceil(filteredClients.value.length / itemsPerPage.value);
// });

// const paginatedClients = computed(() => {
//   const start = (currentPage.value - 1) * itemsPerPage.value;
//   const end = start + itemsPerPage.value;
//   return filteredClients.value.slice(start, end);
// });

// const paginationStart = computed(() => {
//   if (filteredClients.value.length === 0) return 0;
//   return (currentPage.value - 1) * itemsPerPage.value + 1;
// });

// const paginationEnd = computed(() => {
//   return Math.min(
//     currentPage.value * itemsPerPage.value,
//     filteredClients.value.length
//   );
// });

// const displayedPages = computed(() => {
//   const delta = 2;
//   const range = [];
//   const rangeWithDots = [];
//   let l;

//   for (let i = 1; i <= totalPages.value; i++) {
//     if (
//       i === 1 ||
//       i === totalPages.value ||
//       (i >= currentPage.value - delta && i <= currentPage.value + delta)
//     ) {
//       range.push(i);
//     }
//   }

//   range.forEach((i) => {
//     if (l) {
//       if (i - l === 2) {
//         rangeWithDots.push(l + 1);
//       } else if (i - l !== 1) {
//         rangeWithDots.push("...");
//       }
//     }
//     rangeWithDots.push(i);
//     l = i;
//   });

//   return rangeWithDots;
// });

// // Watch for changes that should reset pagination
// watch([searchQuery, filterStatus, itemsPerPage], () => {
//   resetPagination();
// });

// Methods
// const resetPagination = () => {
//   currentPage.value = 1;
// };

// const goToPage = (page) => {
//   if (page !== "..." && page >= 1 && page <= totalPages.value) {
//     currentPage.value = page;
//   }
// };

// const previousPage = () => {
//   if (currentPage.value > 1) {
//     currentPage.value--;
//   }
// };

// const nextPage = () => {
//   if (currentPage.value < totalPages.value) {
//     currentPage.value++;
//   }
// };

// const goToFirstPage = () => {
//   currentPage.value = 1;
// };

// const goToLastPage = () => {
//   currentPage.value = totalPages.value;
// };

// CRUD Methods (same as before)
// const openCreateModal = () => {
//   modalMode.value = "create";
//   formData.value = {
//     name: "",
//     email: "",
//     phone: "",
//     verified: false,
//   };
//   showModal.value = true;
// };

// const openEditModal = (client) => {
//   modalMode.value = "edit";
//   formData.value = { ...client };
//   showModal.value = true;
// };

const closeModal = () => {
  showModal.value = false;
};

const saveClient = () => {
  if (modalMode.value === "create") {
    const newClient = {
      ...formData.value,
      id: clients.value.length + 1,
      tickets: [],
    };
    clients.value.push(newClient);
  } else {
    const index = clients.value.findIndex((c) => c.id === formData.value.id);
    if (index !== -1) {
      clients.value[index] = { ...formData.value };
    }
  }
  closeModal();
};

const viewTickets = (client) => {
  selectedClient.value = client;
  showTicketsModal.value = true;
};

const closeTicketsModal = () => {
  showTicketsModal.value = false;
  selectedClient.value = null;
};

// const confirmDelete = (client) => {
//   clientToDelete.value = client;
//   showDeleteModal.value = true;
// };

const closeDeleteModal = () => {
  showDeleteModal.value = false;
  clientToDelete.value = null;
};

const deleteClient = () => {
  const index = clients.value.findIndex(
    (c) => c.id === clientToDelete.value.id
  );
  if (index !== -1) {
    clients.value.splice(index, 1);
  }
  closeDeleteModal();
};
</script>
